import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import type { Query } from '@tanstack/react-query';
import { get, set, del } from 'idb-keyval';

/**
 * IndexedDB-backed storage for TanStack Query.
 */
const idbStorage = {
	getItem: (key: string): Promise<string | null> => get<string>(key).then((v) => v ?? null),
	setItem: (key: string, value: string): Promise<void> => set(key, value),
	removeItem: (key: string): Promise<void> => del(key),
};

export const IMAGE_CACHE_KEY = 'easyclaim-image-cache';

export const imagePersister = createAsyncStoragePersister({
	storage: idbStorage,
	key: IMAGE_CACHE_KEY,
	throttleTime: 1000,
});

export function shouldPersistQuery(query: Query): boolean {
	return Array.isArray(query.queryKey) && query.queryKey[0] === 'img';
}

export function shouldDehydrateQuery(
	query: Query<unknown, Error, unknown, readonly unknown[]>
): boolean {
	return shouldPersistQuery(query) && query.state.status === 'success';
}
